import { Controller } from "@hotwired/stimulus"

// Copies default URL from a hidden element into a text field on click.
export default class extends Controller {
  static targets = ["source", "destination"]

  copy() {
    this.destinationTarget.value = this.sourceTarget.textContent
  }
}
